const rutValidator = (value) => {
  let rut = value;
  let dv = rut.slice(-1);

  if (typeof rut !== 'string') {
    return false;
  }
  if (!/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(rut)) {
    return false;
  }
  if (/^0+/.test(rut)) {
    return false;
  }

  rut = typeof rut === 'string'
    ? rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase()
    : '';

  const cuerpo = rut.slice(0, -1);
  let suma = 0;
  let multiplo = 2;
  let index = 0;

  for (let i = 1; i <= cuerpo.length; i += 1) {
    index = multiplo * rut.charAt(cuerpo.length - i);
    suma += index;
    multiplo = multiplo < 7 ? multiplo + 1 : 2;
  }
  const dvEsperado = 11 - (suma % 11);

  dv = (dv === 'K' || dv === 'k') ? 10 : parseInt(dv, 10);
  dv = (dv === 0) ? 11 : parseInt(dv, 10);

  return dv === dvEsperado;
};

export default rutValidator;